<template>
  <UContainer>
    <ExpandableList v-slot="{ displayItems }" :items="prideEntries" :limit="9">
      <CommonGridCards
        :items="displayItems"
        :pending="pending"
        empty-text="Нет данных о выдающихся учениках"
      >
        <template #card="{ item }">
          <CommonCard
            :item="item"
            image-top-left="directions"
            title-right="directions"
            description-under-left="trainer"
            :ui="{
              title: 'max-sm:line-clamp-1',
            }"
          />
        </template>
      </CommonGridCards>
    </ExpandableList>
  </UContainer>
</template>

<script lang="ts" setup>
import ExpandableList from '~/components/ExpandableList.vue'

defineOptions({
  name: 'TrainerDetailOurPride',
})

const { routeId } = useRouteId()

const trainerStore = useTrainerStore()
const { prideEntries } = storeToRefs(trainerStore)

const { pending } = await useAppAsyncData(
  `trainer-${routeId}-our-pride`,
  async () => {
    await trainerStore.fetchPrideEntries(routeId)
  },
)
</script>

<style lang="scss" scoped>
:deep(.common-card) {
  --card-height: 416px;
  --card-image-height: 240px;

  @include max-xl {
    --card-height: 358px;
    --card-image-height: 200px;
  }

  @include max-md {
    --card-height: 330px;
    --card-image-height: 155px;

    :deep(.body-header) {
      display: none;
    }
  }
}
</style>
